import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const OverlayStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.overlay};
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const Wrapper = styled.div<{ zIndex?: number }>`
  ${OverlayStyles};
  padding: ${rem(8)};
  ${({ theme }) => theme.media('sm')} {
    padding: ${rem(20)};
  }
  /* Optional override of the default z-index (100). The base 100 sits *below*
     the header on purpose (e.g. the search-results overlay), so only callers
     that must float above the header — modals — pass a higher value. */
  ${({ zIndex }) =>
    zIndex !== undefined &&
    css`
      z-index: ${zIndex};
    `}
`;

interface OverlayProps {
  children: any;
  zIndex?: number;
}

class Overlay extends React.PureComponent<OverlayProps> {
  public render() {
    return <Wrapper zIndex={this.props.zIndex}>{this.props.children}</Wrapper>;
  }
}

export default Overlay;
